import { render } from "./UserReview.vue?vue&type=template&id=f8f5dd68&scoped=true"
import script from "./UserReview.vue?vue&type=script&lang=js"
export * from "./UserReview.vue?vue&type=script&lang=js"

import "./UserReview.vue?vue&type=style&index=0&id=f8f5dd68&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8f5dd68"]])

export default __exports__